import React, { Component } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'

import Input from '../../common/Input'

import * as Strings from './strings'
import * as Constants from '../../../helpers/Constants'

class TwoInputModal extends Component {
  render() {
    const {
      show,
      onHide,
      placeholders,
      inputs,
      classes,
      header,
      information,
      onDone,
      onChange1,
      onChange2,
      errors,
      loading = false,
      language,
      secretInputs = [false, false]
    } = this.props

    return (
      <Dialog
        open={show}
        aria-labelledby={'form-dialog-title'}
        classes={{ paperScrollPaper: classes.container }}
      >
        <DialogTitle id={'form-dialog-title'}>{header}</DialogTitle>
        <DialogContent>
          <DialogContentText>{information}</DialogContentText>
          {errors[2] === '' ? null : (
            <p style={{ fontSize: 12, color: '#e57373' }}>{errors[2]}</p>
          )}
          <Input
            placeholder={placeholders[0]}
            value={inputs[0]}
            onChange={text => onChange1(text)}
            error={errors[0]}
            type={secretInputs[0] ? 'password' : null}
          />
          <Input
            placeholder={placeholders[1]}
            value={inputs[1]}
            onChange={text => onChange2(text)}
            error={errors[1]}
            type={secretInputs[1] ? 'password' : null}
          />
        </DialogContent>
        {loading ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 15
            }}
          >
            <CircularProgress
              style={{ color: Constants.WHITE_LABEL.colors.primary }}
              thickness={6}
              size={20}
            />
          </div>
        ) : (
          <DialogActions>
            <Button
              onClick={() => onHide()}
              classes={{ label: classes.warningButtonText }}
            >
              {Strings.default.CANCEL[language]}
            </Button>
            <Button
              onClick={() => onDone()}
              classes={{ label: classes.successButtonText }}
            >
              {Strings.default.DONE[language]}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    )
  }
}

const Styles = {
  container: {
    width: '100%'
  },
  successButtonText: {
    color: Constants.WHITE_LABEL.colors.primary
  },
  warningButtonText: {
    color: Constants.WHITE_LABEL.colors.warning
  }
}

export default withStyles(Styles)(TwoInputModal)



// WEBPACK FOOTER //
// ./src/components/common/TwoInputModal/index.js